export default __webpack_public_path__ + "static/cutoffs-0386105fae087fe65445b4c831f66836.png";